import { Tooltip } from 'platform/components';
import { HStack } from 'platform/foundation-tw';
import { Link } from 'react-router-dom';
import { isNil } from 'ramda';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getTooltipProps } from '../../utils/getTooltipProps';
type LinkValue = {
  label: string;
  url: string;
} | null;
type LinkCellRendererProps = CellRendererProps<LinkValue> & {
  getTooltipProps?: TooltipGetter;
};
const stopPropagationOnRef = (ref: HTMLAnchorElement | null) => {
  if (!ref) {
    return;
  }
  ref.onclick = event => event.stopPropagation();
};
export function LinkCellRenderer(props: LinkCellRendererProps) {
  const className = getCellClassName(props.column);
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
  if (isNil(props.value)) {
    return null;
  }
  return <Tooltip {...tooltipProps}>
      <div className={className}>
        <HStack>
          <Link to={props.value.url} ref={stopPropagationOnRef}>
            {props.value.label}
          </Link>
        </HStack>
      </div>
    </Tooltip>;
}